<template>
    <v-container id="auto-assign-hold">
        <v-row class="mx-1 mb-5 mt-1 heading-title">            
            <v-switch
                v-model="assignmentOnHold"
                :label="`Auto-Assign Hold`"
                @blur="saveAutoAssignHold"
            />
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-subheader class="pl-0">
                    {{ assignLimitText }}
                </v-subheader>                
            </v-col>
        </v-row>
        <v-row class="mt-8">
            <v-col cols="12">
                <v-slider
                    v-model="slider"
                    label="Assigned Limit"
                    thumb-label="always"
                    min="0"
                    max="500"
                    @blur="saveAutoAssignHold"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-subheader class="pl-0">
                    {{ alternateText }}
                </v-subheader>                
            </v-col>
        </v-row> 
        <v-row>
            <v-col cols="12">
                <v-autocomplete
                    v-model="alternateLocator"
                    :items="companyLocators"
                    item-text="name"
                    item-value="value"
                    label="Alternate Locator"
                    hint="Select an Alternate Locator"
                    placeholder="Select an Alternate Locator"
                    @blur="saveAutoAssignHold"                   
                />
            </v-col>
        </v-row>   
    </v-container>
</template>

<script>
import webtmsBackend from '@/services/webtmsBackend';
import { guidEqual } from '@/utils/guid.js';
import {  getEditUserOption} from '@/utils/options.js';
export default {
    name: 'AutoAssignHold',
    data() {
        return {
            title: 'Auto Assign Hold',
            assignLimitText: 'You can specify a Maximum number of assigned tickets for this locator. If a ticket is auto-assigned to this locator and they have reached their Assigned limit, then the ticket will be assigned to the Alternate Locator (if specified.) An Assigned Limit of 0 means there is no limit.',
            alternateText: 'Specify an Alternate Locator to receive assigned tickets when this locator is either On Auto-Assign Hold, has reached their Assigned Ticket Limit, or if they are on Vacation (which can be specified below.)',
            slider: 0,
            alternateLocator:'',
            assignmentOnHold: false,
        };
    },
    computed: {
        companyLocators() {
            let companyLocators= [];
            companyLocators.push({value: '',name: '(No Alternate)'});
            let data = this.$store.getters.companyUsers;
            let locators = data.filter(item => { return item.ingroup.includes('Locator');});
            for(let locator of locators) {
                if (guidEqual(locator.uid, this.$store.getters.editUser.uid)) {
                    continue;
                }
                let locatorName = locator.name;
                let locatorAccount = locator.account;
                companyLocators.push({ value: locatorAccount, name: `${locatorAccount} : ${locatorName}` });
            }
            return companyLocators;
        },
        getEditUser() {
            return this.$store.getters.editUser;
        },
        getUserDetails() {
            return this.$store.getters.user;
        },
        getCompany() {
            return this.$store.getters.company;
        },
    },
    created() {
        this.setFormData();
    },
    methods: {
        setFormData() {            
            if(this.$route.query.id) { 
                this.isEditUser = true;
            }
            if(this.getEditUser) {
                if (this.getEditUser?.userOptions) {
                    this.slider = getEditUserOption('ASSIGNED_TICKET_LIMIT') || this.slider;
                    this.alternateLocator = getEditUserOption('ALTERNATE_LOCATOR') || this.alternateLocator;
                    this.assignmentOnHold = getEditUserOption('ASSIGNMENT_ON_HOLD') || this.assignmentOnHold;
                }
            }
        },
        saveAutoAssignHold() {
            const options = [
                { option: 'ASSIGNED_TICKET_LIMIT', value: this.slider },
                { option: 'ALTERNATE_LOCATOR', value: this.alternateLocator },
                { option: 'ASSIGNMENT_ON_HOLD', value: this.assignmentOnHold },
            ];

            options.forEach(({ option, value }) => {
                const userOption = this.getEditUser.userOptions.find(o => o.option === option);
                if (userOption) {
                    userOption.value = value;
                // } else {
                //     this.getEditUser.userOptions.push({ option, value });
                }
            });

            this.$store.commit('SET_EDIT_USER', this.getEditUser);
        },
        async saveUser() {
            if(this.getEditUser.account) {
                this.getEditUser.account = this.getEditUser.account.toUpperCase();
            }
            let payload = {
                account: this.getEditUser.account,
                cid: this.getCompany.cid,
                ingroup: this.getEditUser.ingroup,
                name: this.getEditUser.name,
                password: this.getEditUser.password,
                passwordConfirm: this.getEditUser.passwordConfirm
            };

            try {
                this.$emit('start-loader');
                let result = await webtmsBackend.addUser(payload);
                if(result.err) {
                    this.$emit('stop-loader');
                    throw result.err;
                }
                if(result.result === 'OK') {
                    let userObject = await webtmsBackend.getUser(result.uid);
                    if(userObject) {
                        if(this.getEditUser.company === '') {
                            this.getEditUser.company = userObject.company;
                        }
                        this.getEditUser.account = userObject.account;
                        userObject = { ...userObject, ...this.getEditUser };
                        delete userObject.userCompanies;
                        delete userObject.RECEIVE_OVERDUE_NOTIFICATION;
                        delete userObject.RECEIVE_COMPANY_EOD_AUDIT;
                        delete userObject.RECEIVE_COMPANY_EOD_REPORT;
                        delete userObject.RECEIVE_SYSTEM_SOD;
                        delete userObject.RECEIVE_SYSTEM_EOD;
                        delete userObject.RECEIVE_SYSTEM_CHECK_ERRORS;
                        delete userObject.RECEIVE_OVERDUE_NOTIFICATION_INTERVAL;
                        delete userObject.ALTERNATE_LOCATOR;
                        delete userObject.ASSIGNED_TICKET_LIMIT;
                        delete userObject.ASSIGNMENT_ON_HOLD;
                        delete userObject.FORCE_ALTERNATE_LOCATOR;
                        delete userObject.EMAIL_ASSIGNED_TICKETS;
                        delete userObject.VACATION1;
                        delete userObject.VACATION2;
                        delete userObject.VACATION3;
                        delete userObject.VACATION4;
                        delete userObject.VACATION5;
                        delete userObject.user_level;
                        
                        let updateUserResponse = await webtmsBackend.updateUser({uid: result.uid, ...userObject});
                        if(updateUserResponse.status === 'OK') {
                            this.$emit('stop-loader');
                            this.$store.dispatch('setSnackbar', { text: `User account "${updateUserResponse.user.name}" created successfully.` });
                            this.$store.commit('SET_EDIT_USER', null);
                            this.$router.push('users');
                        }
                        if(updateUserResponse.err) {
                            this.$emit('stop-loader');
                            this.$store.dispatch('setSnackbar', { color:'error', text: updateUserResponse.err });
                            this.$store.commit('SET_EDIT_USER', null);
                            this.$router.push('users');
                        }
                    }
                }
            } catch(error) {
                this.$emit('stop-loader');
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
                this.$store.commit('SET_EDIT_USER', null);
                this.$router.push('users');
            }
        },        
        async editUser() {
            try{
                this.saveAutoAssignHold();
                let result = await webtmsBackend.updateUser({uid: this.$route.query.id, ...this.getEditUser});
                if(result.status === 'OK') {
                    if(this.getEditUser.account === this.getUserDetails.account) {
                        const getUserResult = await webtmsBackend.getUserObject(this.getUserDetails.uid);
                        this.$store.commit('SET_USER', getUserResult);
                    }
                    this.$store.dispatch('setSnackbar', { text: `User account "${result.user.name}" updated successfully.` });
                    this.$store.commit('SET_EDIT_USER', null);
                    this.$router.push('users');
                }
                if(result.err) {
                    this.$store.dispatch('setSnackbar', { color:'error', text: result.err });
                }
            } catch(error) {
                this.$store.dispatch('setSnackbar', { color:'error', text: error });
            }
        },
    },
};
</script>

<style>

</style>